/** Raw fixtures — imported only by communicationsMockAdapter.js */

export const MOCK_PROJECT_NUMBER = 'PRJ-2024-047';

export const MOCK_MS_RESOURCE_PICKERS = {
  outlookFolders: [
    { id: 'f1', label: 'Inbox/Projects/PRJ-2023-112 - Harbor View' },
    { id: 'f2', label: 'Inbox/Projects/PRJ-2024-031 - Civic Center' },
  ],
  teams: [
    { id: 't1', label: 'Riverside Tower - Project Team', channels: ['#general', '#structural', '#mep'] },
    { id: 't2', label: 'CODiii Internal', channels: ['#general'] },
  ],
  plannerPlans: [
    { id: 'p1', label: 'AEC Deliverables Template' },
    { id: 'p2', label: 'RFI Tracker Template' },
  ],
};

export const DEFAULT_CONNECTIONS = {
  outlook: {
    connected: true,
    name: `Inbox/Projects/${MOCK_PROJECT_NUMBER} - Riverside Tower`,
    url: '#',
    unreadCount: 6,
    latestActivity: 'J. Chen — Level 3 corridor fire rating',
    alignmentStatus: 'conflict',
  },
  teams: {
    connected: true,
    name: 'Riverside Tower - Project Team',
    channel: '#general',
    url: '#',
    latestActivity: 'M. Ortiz — standup FRR recap in #general',
    alignmentStatus: 'conflict',
  },
  planner: {
    connected: true,
    name: 'Riverside Tower Deliverables',
    url: '#',
    openTasks: 8,
    latestActivity: 'Confirm fire rating assumption — due 6/20',
    alignmentStatus: 'partial',
  },
};

export const MOCK_FEED_ITEMS = [
  // ── Outlook (6) ──────────────────────────────────────────────
  {
    id: 'feed-o1',
    source: 'outlook',
    threadKey: 'fire-rating-l3',
    threadTopic: 'Fire rating — Level 3 corridor',
    timestamp: '2026-06-18T09:10:00Z',
    author: 'J. Chen',
    subject: 'RE: Level 3 corridor fire rating',
    preview: 'Proceed with 2-hour FRR per code consultant memo — please confirm before DD issue.',
    body: 'Team,\n\nProceed with **2-hour FRR** for the Level 3 corridor assembly per our email thread of 3/12. This aligns with the code consultant memo attached.\n\nRegards,\nJ. Chen',
    decisionPosition: '2-hour FRR',
    linkedRefs: ['BC-7.3.4'],
    attachments: ['CodeConsultant_Memo_Mar12.pdf'],
    status: '',
  },
  {
    id: 'feed-o2',
    source: 'outlook',
    threadKey: 'rfi-014',
    threadTopic: 'RFI-014 — structural embed at grid C4',
    timestamp: '2026-06-14T16:40:00Z',
    author: 'S. Patel',
    subject: 'RFI-014 response — embed plate thickness',
    preview: 'Confirmed 3/8" embed plate per structural sketch SK-S-014. Closing RFI.',
    body: 'RFI-014 closed: confirmed **3/8" embed plate** per structural sketch SK-S-014. No further action required.',
    decisionPosition: '3/8" embed plate',
    linkedRefs: ['RFI-014'],
    attachments: ['SK-S-014.pdf'],
    status: '',
  },
  {
    id: 'feed-o3',
    source: 'outlook',
    threadKey: 'mep-coordination',
    threadTopic: 'MEP coordination — ceiling plenum',
    timestamp: '2026-06-15T10:00:00Z',
    author: 'A. Kim',
    subject: 'Ceiling plenum coordination — L2 meeting invite',
    preview: 'Coordination session 6/20 @ 10am — duct vs beam conflicts on Level 2.',
    body: 'Scheduling coordination meeting for **6/20 at 10:00 AM** to resolve duct vs beam conflicts on Level 2. Zoom link attached.',
    decisionPosition: 'Meeting 6/20',
    linkedRefs: ['CR-018'],
    attachments: ['L2_Coordination_Agenda.pdf'],
    status: '',
  },
  {
    id: 'feed-o4',
    source: 'outlook',
    threadKey: 'client-dd-deadline',
    threadTopic: 'Client DD package deadline',
    timestamp: '2026-06-12T08:00:00Z',
    author: 'R. Walsh (Client PM)',
    subject: 'DD submission deadline — July 8',
    preview: 'Design Development package due July 8. Include updated code summary and resolved RFIs.',
    body: 'Design Development package due **July 8**. Include updated code summary, life-safety narrative, and all resolved RFIs.',
    decisionPosition: 'Due July 8',
    linkedRefs: ['CR-001'],
    attachments: ['DD_Submittal_Checklist.xlsx'],
    status: '',
  },
  {
    id: 'feed-o5',
    source: 'outlook',
    threadKey: 'geotech-report',
    threadTopic: 'Geotechnical report — borings B-1 through B-6',
    timestamp: '2026-06-11T14:30:00Z',
    author: 'GeoTech Partners',
    subject: 'Final geotechnical report — Riverside Tower',
    preview: 'Allowable bearing 4,000 psf — recommend deep foundations at grid lines 4-7.',
    body: 'Please find attached the final geotechnical report. **Allowable bearing pressure: 4,000 psf.** Deep foundations recommended at grid lines 4–7 due to soft clay layer.',
    decisionPosition: '4,000 psf bearing',
    linkedRefs: ['STR-201', 'CR-022'],
    attachments: ['Geotech_Report_Final.pdf'],
    status: '',
  },
  {
    id: 'feed-o6',
    source: 'outlook',
    threadKey: 'zoning-variance',
    threadTopic: 'Zoning setback variance — north property line',
    timestamp: '2026-06-10T11:15:00Z',
    author: 'City Planning Dept.',
    subject: 'Variance application VAR-2026-041 — preliminary approval',
    preview: '3-ft setback reduction approved pending landscape plan revision.',
    body: 'Variance application **VAR-2026-041** receives preliminary approval for a 3-ft north setback reduction, contingent on revised landscape plan submission by 6/28.',
    decisionPosition: '3-ft variance approved',
    linkedRefs: ['ZN-004'],
    attachments: ['VAR-2026-041_Letter.pdf'],
    status: '',
  },

  // ── Microsoft Teams (6) ──────────────────────────────────────
  {
    id: 'feed-t1',
    source: 'teams',
    threadKey: 'fire-rating-l3',
    threadTopic: 'Fire rating — Level 3 corridor',
    timestamp: '2026-06-18T09:30:00Z',
    author: 'M. Ortiz',
    subject: 'Standup — corridor FRR',
    preview: 'Standup agreed 1-hour FRR based on shaft wall detail S-201. @J.Chen — can you confirm?',
    body: 'Quick recap from standup: we are proceeding with **1-hour FRR** for the L3 corridor based on the existing shaft wall detail on S-201. @J.Chen please confirm if this conflicts with the email chain.',
    decisionPosition: '1-hour FRR',
    linkedRefs: ['BC-7.3.4'],
    attachments: [],
    status: 'thread',
  },
  {
    id: 'feed-t2',
    source: 'teams',
    threadKey: 'rfi-014',
    threadTopic: 'RFI-014 — structural embed at grid C4',
    timestamp: '2026-06-14T17:05:00Z',
    author: 'S. Patel',
    subject: 'RFI-014 closed',
    preview: 'Aligned with email — 3/8" plate governs. Updating S-201 tonight.',
    body: 'Aligned with email — **3/8" plate**, sketch SK-S-014 is governing. Closing the loop in Planner.',
    decisionPosition: '3/8" embed plate',
    linkedRefs: ['RFI-014'],
    attachments: [],
    status: 'thread',
  },
  {
    id: 'feed-t3',
    source: 'teams',
    threadKey: 'mep-coordination',
    threadTopic: 'MEP coordination — ceiling plenum',
    timestamp: '2026-06-17T15:20:00Z',
    author: 'A. Kim',
    subject: '#mep — L2 clash update',
    preview: 'Revit clash report: 4 hard clashes, 2 soft. Need structural sign-off before 6/20.',
    body: 'Posted updated clash list from Revit — **4 hard clashes, 2 soft** on L2 plenum. Need structural sign-off before the 6/20 meeting.',
    decisionPosition: '4 hard clashes',
    linkedRefs: ['CR-018'],
    attachments: ['L2_Clash_Report_v2.xlsx'],
    status: 'thread',
  },
  {
    id: 'feed-t4',
    source: 'teams',
    threadKey: 'curtain-wall-review',
    threadTopic: 'Curtain wall shop drawing review',
    timestamp: '2026-06-16T13:45:00Z',
    author: 'J. Chen',
    subject: '#general — CW shop dwgs',
    preview: 'Reviewed CW-100 series — anchor spacing does not match A-501. Hold release.',
    body: 'Reviewed CW-100 series shop drawings. **Anchor spacing at floor 14 does not match A-501.** Recommend hold on release until revised submittal.',
    decisionPosition: 'Hold release',
    linkedRefs: ['A-501', 'CR-031'],
    attachments: [],
    status: 'thread',
  },
  {
    id: 'feed-t5',
    source: 'teams',
    threadKey: 'weekly-pm-sync',
    threadTopic: 'Weekly PM sync — June 16',
    timestamp: '2026-06-16T16:00:00Z',
    author: 'D. Nguyen (PM)',
    subject: '#general — weekly sync notes',
    preview: 'DD on track for 7/8. Action: resolve fire rating before Friday. Budget at 68%.',
    body: '**Weekly sync notes:** DD on track for 7/8. Action items: resolve fire rating discrepancy by Friday, geotech incorporation into STR-201 by 6/22. Budget burn at 68%.',
    decisionPosition: 'DD on track',
    linkedRefs: ['CR-001'],
    attachments: [],
    status: 'thread',
  },
  {
    id: 'feed-t6',
    source: 'teams',
    threadKey: 'steel-camber',
    threadTopic: 'Steel camber — floor 12 girders',
    timestamp: '2026-06-13T10:30:00Z',
    author: 'M. Ortiz',
    subject: '#structural — camber question',
    preview: 'Fabricator asking if 3/4" camber on G-12.1 is still required per latest loads.',
    body: 'Steel fabricator asking whether **3/4" camber on G-12.1** is still required per the latest live load revision. Need confirmation before shop release.',
    decisionPosition: '3/4" camber TBD',
    linkedRefs: ['S-301', 'RFI-019'],
    attachments: [],
    status: 'thread',
  },

  // ── Planner (6) ──────────────────────────────────────────────
  {
    id: 'feed-p1',
    source: 'planner',
    threadKey: 'fire-rating-l3',
    threadTopic: 'Fire rating — Level 3 corridor',
    timestamp: '2026-06-18T11:00:00Z',
    author: 'D. Nguyen',
    subject: 'Confirm fire rating assumption',
    preview: 'Resolve Outlook vs Teams discrepancy before DD submittal. Due 6/20.',
    body: 'Resolve discrepancy between Outlook email (2-hour) and Teams standup (1-hour) before DD submission. **Due 6/20.**',
    decisionPosition: 'Pending confirmation',
    linkedRefs: ['BC-7.3.4', 'DD-Package-A'],
    attachments: [],
    status: 'not_started',
  },
  {
    id: 'feed-p2',
    source: 'planner',
    threadKey: 'rfi-014',
    threadTopic: 'RFI-014 — structural embed at grid C4',
    timestamp: '2026-06-14T17:30:00Z',
    author: 'S. Patel',
    subject: 'RFI-014 — update embed detail on S-201',
    preview: 'Embed detail updated on S-201. Marked complete.',
    body: 'Task completed. Embed detail updated on S-201 per RFI-014 resolution.',
    decisionPosition: '3/8" embed plate',
    linkedRefs: ['RFI-014'],
    attachments: [],
    status: 'complete',
  },
  {
    id: 'feed-p3',
    source: 'planner',
    threadKey: 'mep-coordination',
    threadTopic: 'MEP coordination — ceiling plenum',
    timestamp: '2026-06-17T09:00:00Z',
    author: 'A. Kim',
    subject: 'Resolve L2 plenum clashes',
    preview: 'Structural review of 4 hard clashes. Due 6/19.',
    body: 'Due before 6/20 coordination meeting. Assign structural reviewer for 4 hard clashes.',
    decisionPosition: 'Due 6/19',
    linkedRefs: ['CR-018'],
    attachments: [],
    status: 'in_progress',
  },
  {
    id: 'feed-p4',
    source: 'planner',
    threadKey: 'client-dd-deadline',
    threadTopic: 'Client DD package deadline',
    timestamp: '2026-06-12T09:00:00Z',
    author: 'D. Nguyen',
    subject: 'DD package — master checklist',
    preview: '12 deliverables: 8 in progress, 4 not started. Target 7/8.',
    body: 'Master DD checklist created. **12 deliverables** — 8 in progress, 4 not started.',
    decisionPosition: '12 deliverables',
    linkedRefs: ['CR-001'],
    attachments: [],
    status: 'in_progress',
  },
  {
    id: 'feed-p5',
    source: 'planner',
    threadKey: 'geotech-report',
    threadTopic: 'Geotechnical report — borings B-1 through B-6',
    timestamp: '2026-06-12T14:00:00Z',
    author: 'M. Ortiz',
    subject: 'Incorporate geotech into STR-201 foundation plan',
    preview: 'Update foundation plan with 4,000 psf bearing and deep foundations at grid 4-7.',
    body: 'Incorporate geotechnical report findings into STR-201. Deep foundations at grid lines 4–7.',
    decisionPosition: 'Due 6/22',
    linkedRefs: ['STR-201', 'CR-022'],
    attachments: [],
    status: 'in_progress',
  },
  {
    id: 'feed-p6',
    source: 'planner',
    threadKey: 'curtain-wall-review',
    threadTopic: 'Curtain wall shop drawing review',
    timestamp: '2026-06-17T08:30:00Z',
    author: 'J. Chen',
    subject: 'CW shop drawing resubmittal review',
    preview: 'Review revised CW-100 anchor spacing after fabricator resubmittal.',
    body: 'Review revised CW-100 series for anchor spacing compliance with A-501. Hold bucket until fire rating resolved.',
    decisionPosition: 'Review by 6/21',
    linkedRefs: ['A-501', 'CR-031'],
    attachments: [],
    status: 'not_started',
  },
];

export const MOCK_COMMUNICATIONS_ISSUES = [
  {
    id: 'ci-1',
    code: 'COM-001',
    topic: 'Fire rating mismatch across Outlook and Teams',
    threadTopic: 'Fire rating — Level 3 corridor',
    threadKey: 'fire-rating-l3',
    status: 'open',
    platform: 'Teams',
    severity: 'high',
  },
  {
    id: 'ci-2',
    code: 'COM-002',
    topic: 'Planner task pending — fire rating not confirmed',
    threadTopic: 'Fire rating — Level 3 corridor',
    threadKey: 'fire-rating-l3',
    status: 'in_progress',
    platform: 'Planner',
    severity: 'medium',
  },
  {
    id: 'ci-3',
    code: 'COM-003',
    topic: 'MEP clash count differs between email and Teams',
    threadTopic: 'MEP coordination — ceiling plenum',
    threadKey: 'mep-coordination',
    status: 'open',
    platform: 'Outlook',
    severity: 'medium',
  },
  {
    id: 'ci-4',
    code: 'COM-004',
    topic: 'RFI-014 resolution aligned across platforms',
    threadTopic: 'RFI-014 — structural embed',
    threadKey: 'rfi-014',
    status: 'resolved',
    platform: 'All',
    severity: 'low',
  },
  {
    id: 'ci-5',
    code: 'COM-005',
    topic: 'Curtain wall shop drawings on hold pending anchor fix',
    threadTopic: 'Curtain wall shop drawing review',
    threadKey: 'curtain-wall-review',
    status: 'open',
    platform: 'Teams',
    severity: 'medium',
  },
  {
    id: 'ci-6',
    code: 'COM-006',
    topic: 'Steel camber on G-12.1 — fabricator awaiting confirmation',
    threadTopic: 'Steel camber — floor 12 girders',
    threadKey: 'steel-camber',
    status: 'in_progress',
    platform: 'Teams',
    severity: 'low',
  },
];

export const MOCK_PRODUCTIVITY = {
  contractProgressPct: 68,
  billableHours: 412,
  billableHoursTarget: 600,
  teamUtilizationPct: 82,
  budgetSpent: 284000,
  budgetTotal: 420000,
  teamRows: [
    { id: 'u1', name: 'J. Chen', role: 'Architect', hoursWeek: 38, billablePct: 88, deliverables: 4 },
    { id: 'u2', name: 'M. Ortiz', role: 'Structural', hoursWeek: 42, billablePct: 91, deliverables: 3 },
    { id: 'u3', name: 'S. Patel', role: 'Structural', hoursWeek: 36, billablePct: 85, deliverables: 5 },
    { id: 'u4', name: 'A. Kim', role: 'MEP', hoursWeek: 40, billablePct: 78, deliverables: 2 },
  ],
};

export const MOCK_ALIGNMENT_RESPONSES = {
  'fire-rating-l3': {
    summary: 'Outlook (J. Chen, 6/16) documents a 2-hour FRR decision citing the code consultant memo. Teams (M. Ortiz, 6/17) records a 1-hour FRR agreement from standup referencing shaft wall detail S-201. Planner has an open task to confirm the assumption before DD submission.',
    suggestedResolution: 'Schedule a 15-minute alignment call with J. Chen and M. Ortiz to confirm governing document (code memo vs S-201 detail), then update Planner task and send a single confirmation email to the project distribution list.',
    sourcesCited: ['Outlook — J. Chen, 6/16', 'Teams — #general, M. Ortiz, 6/17', 'Planner — Confirm fire rating assumption'],
  },
};
